import React from 'react';
import { initialState, IState } from './state';
import { reducer } from './reducer';
import { useTask, ITask } from './task';

const Context: React.Context<any> = React.createContext(undefined);

function ContextProvider(props: any) {
  // init reducer
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const task = useTask(dispatch);

  const value: { state: IState; task: ITask } = { state, task };

  return <Context.Provider value={value}>{props.children}</Context.Provider>;
}

const useContext = (): { state: IState; task: ITask } => React.useContext(Context);

export { useContext, ContextProvider };
